import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b-2 border-black bg-white">
      <nav
        aria-label="Primary navigation"
        className="flex min-h-20 items-center"
      >
        <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-4 px-6 py-4">
          <Link
            to="/"
            className="font-serif text-2xl font-black uppercase tracking-tighter transition-all hover:italic focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
          >
            Broadway Muses
          </Link>

          <div className="flex flex-wrap items-center justify-end gap-x-6 gap-y-2">
            <Link
              to="/about"
              className="font-mono text-[10px] font-black uppercase tracking-widest underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
            >
              About Us
            </Link>
            <Link
              to="/journal"
              className="font-mono text-[10px] font-black uppercase tracking-widest underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
            >
              The Lost Boys
            </Link>
            <span
              aria-label="Act 1: Preparation"
              className="hidden border-2 border-black px-4 py-1 font-mono text-[10px] font-black uppercase md:block"
            >
              Act 1: Preparation
            </span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;